import { displayCard, isRedCard } from '../lib/cards'
import type { Card, Street } from '../types/solver'

const TABLE_POSITIONS = ['UTG', 'HJ', 'CO', 'BTN', 'SB', 'BB']

export interface PokerTablePlayer {
  position: string
  stackBb: number
  active?: boolean
  acting?: boolean
  hero?: boolean
}

interface PokerTableProps {
  players: PokerTablePlayer[]
  heroPosition: string
  heroCards: [Card, Card]
  board?: Card[]
  potBb: number
  street: 'preflop' | Street
  actionHistory?: string
}

function TableCard({ card, hole = false }: { card: Card; hole?: boolean }) {
  return <span className={`table-card ${hole ? 'hole' : ''} ${isRedCard(card) ? 'red' : ''}`}>{displayCard(card)}</span>
}

export function PokerTable({ players, heroPosition, heroCards, board = [], potBb, street, actionHistory }: PokerTableProps) {
  const playerMap = new Map(players.map((player) => [player.position, player]))
  const canonical = TABLE_POSITIONS.includes(heroPosition)
    ? TABLE_POSITIONS
    : [...TABLE_POSITIONS.slice(0, 5), heroPosition]
  const heroIndex = canonical.indexOf(heroPosition)
  const ordered = Array.from({ length: canonical.length }, (_, index) => canonical[(heroIndex + index + 1) % canonical.length])

  return (
    <div className="poker-table-wrap" aria-label={`${heroPosition}のポーカーテーブル`}>
      <div className="poker-table">
        <div className="poker-table-rail" />
        <div className="poker-table-felt">
          <div className="table-center">
            <span className="table-street">{street.toUpperCase()}</span>
            <div className={`table-board ${board.length === 0 ? 'empty' : ''}`}>
              {board.length > 0
                ? board.map((card, index) => <TableCard card={card} key={`${card}-${index}`} />)
                : <span>BOARD</span>}
            </div>
            <span className="table-pot">POT <strong>{potBb.toFixed(1)}bb</strong></span>
          </div>
          {actionHistory && <div className="table-action-line">{actionHistory}</div>}
          <div className="table-hero-cards"><TableCard card={heroCards[0]} hole /><TableCard card={heroCards[1]} hole /></div>
        </div>

        {ordered.map((position, index) => {
          const player = playerMap.get(position)
          const isHero = position === heroPosition
          const active = player?.active || isHero
          return <div key={`${position}-${index}`} className={`table-seat seat-${index} ${active ? 'active' : 'folded'} ${isHero ? 'hero' : ''} ${player?.acting ? 'acting' : ''}`}>
            <div className="seat-avatar">{position.slice(0, 1)}</div>
            <div className="seat-copy"><strong>{position}{position === 'BTN' && <i>D</i>}</strong><span>{active ? `${(player?.stackBb ?? 100).toFixed(1)}bb` : street === 'preflop' ? '—' : 'FOLD'}</span></div>
            {player?.acting && <em>TURN</em>}
          </div>
        })}
      </div>
    </div>
  )
}
